module.exports = __webpack_public_path__ + "static/media/og_image.75e39aea.png";